import { Component, Prop } from "vue-property-decorator";
import { ICardInformations } from "../../../config/Absences.config";
import { TypeCongeCompteurEnum } from "../../../dto/GenApi.iNotPaie.Dto/TypeCongeCompteurEnum";
import { mapCompteur } from "../../../Helper/absencesHelper";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { VueBase } from "../../Controls/VueBase";

@Component
export default class CarteCongeLightComponent extends VueBase {
	@Prop({ type: Number, required: true })
	public readonly typeConge!: TypeCongeCompteurEnum;

	@Prop({ type: Date, required: true })
	public readonly exercice!: Date | undefined;

	public dataReady = false;
	public compteur: ICardInformations | null = null;

	public mounted(): void {
    	this.dataReady = false;
    	this.compteur = null;

    	this.fetchData();
	}

	/**
     * Récupère les absences du salarié pour les afficher dans le compteur
     */
	public fetchData(): void {
    	ServicesFactoryInstance.CompteurAbsenceService.getStatuAbsenceByType(this.typeConge, this.exercice, (data) => {
            this.compteur = mapCompteur(data, this.typeConge);
    		this.dataReady = true;
		}, (error) => {
    		NotificationServiceInstance.SendFailed(`Erreur lors de la récupération des absences pour le salarié' : ${error.message}`);
    		this.dataReady = true;
    	});
	}

	/**
    * Formatte un nombre de jours pour l'affichage
    * @param nbJours
    * @returns un nombre de jour adapté à l'affichage
    */
	public formatNumber(nbJours: number): string {
    	return nbJours.toString().replace(".", ",");
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsencesV2/carteCongeLight/carteCongeLight.ts